import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
  location?: string;
  category?: string[];
};

export const getNews = createQueryFn(
  QueryNameSpace.getNews,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const paramsCategory = params?.category?.map((cat) =>
      cat.replace('cat:', ''),
    );

    const { news } = await DigiobcanApi.getNews({
      ...params,
      category: paramsCategory,
    });

    return news.map((item) => ({
      ...item,
      type: 'news',
    }));
  },
);
